import { render, staticRenderFns } from "./RequestTime.vue?vue&type=template&id=9b060ffc&scoped=true"
import script from "./RequestTime.vue?vue&type=script&lang=js"
export * from "./RequestTime.vue?vue&type=script&lang=js"
import style0 from "./RequestTime.vue?vue&type=style&index=0&id=9b060ffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b060ffc",
  null
  
)

export default component.exports